module.exports = __webpack_public_path__ + "img/movie-midia.b6b76503.jpeg";